export default [{
	path: 'online',
	meta: {
		title: '线上采购'
	},
	component: () => import('@/pages/purchase/order_online')
}, {
	path: 'offline',
	meta: {
		title: '线下采购'
	},
	component: () => import('@/pages/purchase/order_offline')
}, {
	path: 'offline/create',
	meta: {
		title: '新建采购单'
	},
	component: () => import('@/pages/purchase/order_offline_create')
}]